// initial state
import config from "./config";
import analysis from "./analysis";
import auth from "./auth";
import site from "./site";
import upload from "./upload";
import user from "./user";
import log from "./log";
import cases from "./cases";
import skill from "./skill";
import show from "./show";
import usertag from "./usertag";
import regard from "./regard";
import make from "./make";
import spot from "./spot";
import banner from "./banner";
import reverb from "./reverb";
import commodity from "./commodity";
import water from "./water";
import water_comment from "./water_comment";
import squad from "./squad";

// api 集合
const types = {};
Object.assign(
  types,
  config,
  analysis,
  auth,
  site,
  log,
  upload,
  user,
  cases,
  skill,
  show,
  usertag,
  regard,
  make,
  banner,
  spot,
  reverb,
  commodity,
  water,
  water_comment,
  squad
);
export default types;
